import Link from "@/components/link";
import { ArrowLeft, Construction } from "lucide-react";
import { TextScramble } from "@/components/text-scramble";
import { useEffect, useState } from "react";
import { Footer } from "@/components/footer";

export default function NotFound() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f7f4] flex flex-col">
      <div className="container mx-auto flex-grow flex flex-col items-center justify-center px-4 py-16">
        <div className="max-w-md w-full text-center space-y-8">
          <div className="flex justify-center">
            <Construction className="h-24 w-24 text-[#e6b800]" strokeWidth={1.5} />
          </div>

          <div className="space-y-4">
            {isMounted ? (
              <h1 className="text-4xl md:text-5xl font-extralight tracking-tight">
                <TextScramble text="Under Construction" className="inline" speed={25} revealRate={0.07} />
              </h1>
            ) : (
              <h1 className="text-4xl md:text-5xl font-extralight tracking-tight">Under Construction</h1>
            )}

            {isMounted ? (
              <p className="text-lg text-gray-600">
                <TextScramble
                  text="This page is currently being built. Please check back later."
                  className="inline"
                  speed={35}
                  revealRate={0.06}
                />
              </p>
            ) : (
              <p className="text-lg text-gray-600">This page is currently being built. Please check back later.</p>
            )}
          </div>

          <div className="pt-8">
            <Link href="/" className="inline-flex items-center text-gray-700 hover:text-gray-900 transition-colors">
              <ArrowLeft size={16} className="mr-2" />
              <span>Return to home</span>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
